var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo insuficiente\">\r\n    <h2> <strong>Tu tarjeta no es Black o Premium titular.</strong> Suscribite para tener Acceso Digital. </h2>\r\n</div>   ";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/header/plan_insuficiente.hbs
// module id = 521
// module chunks = 0